import React from 'react'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import Conversation from './Conversation'
import SmallSelect from 'App/components/fields/SmallSelect'
import VehicleField from 'App/components/fields/VehicleField'
import Loading from 'App/components/Loading'
import Menu from 'react-icons/lib/md/menu'
import styles from './styles.css'
import SearchConversation from './SearchConversation'

export function Fallback({inbox, options, sortBy}) {
  return (
    <div className={styles.conversationsList}>
      <div className={styles.row}>
        <div className={styles.header}>
          <div role="button">
            <Menu size={24} />
          </div>
          <h1>{inbox.name}</h1>
        </div>
      </div>
      <div className={styles.search}>
        <VehicleField value={null} placeholder="Buscar una conversación" />
      </div>
      <div className={styles.row}>
        <div>Chats: {inbox.count}</div>
        <div className={styles.orderBy}>
          <SmallSelect options={options} value={sortBy} />
        </div>
      </div>
      <div className={styles.loading}>
        <Loading />
      </div>
    </div>
  )
}

export default function ConversationList({
  history,
  inbox,
  sortBy,
  setSortBy,
  options,
  toggleSidebar
}) {
  const {conversations} = useQuery({
    query: gql`
      query getConversations($inboxId: ID, $inboxType: String, $sortBy: String) {
        conversations: conversationsByInbox(
          inboxId: $inboxId
          inboxType: $inboxType
          sortBy: $sortBy
        ) {
          _id
          priority
          vehicleId
          isUnreadByAdmin
          lastActivityAt
          lastMessagePreview
          isVehicleTyping
          assignedAdminId
          assignedAdminName
          countryCode
          vehicle {
            _id
            code
            zoneName
            firstName
            lastName
            hasActiveOrders
            categoryId
            approvedAt
            completedOrdersCount
          }
        }
      }
    `,
    variables: {inboxId: inbox._id, inboxType: inbox.type, sortBy},
    pollInterval: 4000
  })

  return (
    <div className={styles.conversationsList}>
      <div className={styles.row}>
        <div className={styles.header}>
          <div role="button" onClick={toggleSidebar}>
            <Menu size={24} />
          </div>
          <h1>{inbox.name}</h1>
        </div>
      </div>
      <div className={styles.search}>
        <SearchConversation history={history} />
      </div>
      <div className={styles.row}>
        <div>Chats: {inbox.count}</div>
        <div className={styles.orderBy}>
          <SmallSelect value={sortBy} onChange={setSortBy} options={options} />
        </div>
      </div>

      {conversations.length > 0 ? (
        conversations.map(conversation => (
          <Conversation
            key={conversation._id}
            conversation={conversation}
            select={() => history.push(`/inbox/conversations/${conversation._id}`)}
          />
        ))
      ) : (
        <div className={styles.row}>
          <p>No hay conversaciones activas</p>
        </div>
      )}
    </div>
  )
}
